export default __webpack_public_path__ + "static/media/ethfan-logo.18283ef5.png";